export enum OutgoingCashOperationTypeEnum {
  paymentToVendor = 0,
  paymentToAdvanceHolder = 1,
  payrollPaymentViaCashAccount = 2,
  cashDepositToBank = 3,
  issueToAnotherCashAccount = 4,
  paymentForOptainedCreditsAndLoans = 5,
  loanToEmployee = 6,
  loanToCounterparty = 7,
  currencyConversion = 8,
  otherExpenses = 9,
  refundToCustomer = 10,
}
